import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles.module.scss";

interface DetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const DetailModal: React.FC<DetailModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
}) => {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleEscKey = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      onClose();
    }
  };

  return (
    <div
      className={styles.detailModalOverlay}
      onClick={handleOverlayClick}
      onKeyDown={handleEscKey}
      tabIndex={-1}
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{title}</h3>
        </div>

        <div className={styles.modalContentWrapper}>
          {/* Botão flutuante que acompanha o scroll */}
          <button
            className={`${styles.modalCloseBtn} ${styles.modalCloseBtnSticky}`}
            onClick={onClose}
            type="button"
            aria-label={t("chatjess.modal.closeModal")}
          >
            <i className="fas fa-times"></i>
          </button>

          <div className={styles.modalContent} ref={contentRef}>
            {content.split("\n").map((line, index) => (
              <p key={index} className={styles.modalText}>
                {line}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailModal;
